
import React, { useEffect, useState } from 'react'
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import { Outlet } from 'react-router-dom';
import jwt_decode from 'jwt-decode'
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import './navbar.css'
import avatar from '../../../src/assets/sandler.jpg'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { useDispatch, useSelector } from 'react-redux'
import { selectAdminClaim, selectLoggedInUser, signOutAsync } from '../auth/authSlice';
import { useSpring, animated, config } from 'react-spring';
import { Link as RouterLink } from 'react-router-dom';
import RefreshIcon from '@mui/icons-material/Refresh';
import CircleIcon from '@mui/icons-material/Circle';
import DeleteIcon from '@mui/icons-material/Delete';
import { emailTemplates } from '../user/templates';
import { deleteTemplateNameAsync, emailBodyTemplateAsync, getEmailTemplateNamesAsync, incrementTemplateClick, loadTemplateDataAsync, selectEmailTemplateNames, setTemplateId, updateEmailBody, updateTemplateAttachment, updateTemplateAttachmentSelectOneS, } from '../user/userSlice';
import {
  ListItemText,
  ListItemIcon,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import EmailIcon from '@mui/icons-material/Email';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import { fetchEmailBlastStatusAsync, emailBlastStatusData } from '../user/userSlice.js'
import Divider from '@mui/material/Divider';

const pages = [];
const settings = [{ name: 'Logout', link: '/logout' },];


const AnimatedSettingsMenu = ({ anchorElUser, onClose, userEmail, settings }) => {

  const dispatch = useDispatch();
  const menuAnimation = useSpring({
    opacity: Boolean(anchorElUser) ? 1 : 0,
    transform: Boolean(anchorElUser) ? 'translate3d(0, 0, 0)' : 'translate3d(0, -20px, 0)',
    vertical: 'top',
    horizontal: 'right',
    height: Boolean(anchorElUser) ? 200 : 0,
    config: {
      tension: 120, // Increase tension for stiffness
      friction: 14, // Increase friction for slower motion
    },
  });

  const handleLogout = () => {
    dispatch(signOutAsync());
    dispatch(updateEmailBody())
    dispatch(updateTemplateAttachment())
  }

  return (
    <Menu
      sx={{ mt: '45px' }}
      id="menu-appbar"
      anchorEl={anchorElUser}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      keepMounted
      TransitionComponent={(props) => (
        <animated.div style={menuAnimation} {...props} />
      )}
      open={Boolean(anchorElUser)}
      onClose={onClose}
    >
      <MenuItem style={{ color: "grey", cursor: 'default' }}>
        {userEmail.email}
      </MenuItem>
      {settings.map((item) => (
        <MenuItem style={{ textDecoration: 'none', color: 'inherit' }} onClick={handleLogout}>
          {item.name}
        </MenuItem>
        // <a href={item.link} ></a>
      ))}

    </Menu>
  );
};


const EmailBlastStatusComponent = () => {

  const dispatch = useDispatch();

  const emailBlastStatus = useSelector(emailBlastStatusData);

  const blastsRunning =
    emailBlastStatus?.data?.queueStatus?.running ?? 0;

  const maxConcurrent =
    emailBlastStatus?.data?.queueStatus?.maxConcurrent ?? 3;

  const emailsQueued =
    emailBlastStatus?.data?.emailsQueued ?? 0;

  const estimatedTime =
    emailBlastStatus?.data?.totalEstimatedTime ?? "0 Minutes";

  const blasts =
    emailBlastStatus?.data?.blasts ?? [];

  const statusLastUpdated =
    emailBlastStatus?.metaData?.requestTime ?? "";

  const handleEmailBlastStatusRefresh = () => {
    dispatch(fetchEmailBlastStatusAsync());
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        color: "white",
        height: "56px",
        mr: 2,
        px: 1,
        minWidth: 460
      }}
    >

      <Tooltip
        arrow
        placement="bottom"
        componentsProps={{
          tooltip: {
            sx: {
              maxWidth: 500,
              p: 0,
              bgcolor: "#263238",      // same background everywhere
              border: "1px solid #455A64",
              borderRadius: 2,
            },
          },
          arrow: {
            sx: {
              color: "#263238",
            },
          },
        }}
        title={
          <Box
            sx={{
              bgcolor: "#263238",
              minWidth: 420,
              maxHeight: 400,
              overflowY: "auto",
              p: 2,
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 700,
                textAlign: "center",
                mb: 2,
                pb: 1,
                borderBottom: "1px solid rgba(255,255,255,0.2)",
              }}
            >
              Active Email Blasts
            </Typography>

            {blasts.length === 0 ? (
              <Typography
                variant="body2"
                align="center"
                sx={{ py: 2 }}
              >
                No active email blasts.
              </Typography>
            ) : (
              blasts.map((blast) => (
                <Box
                  key={blast.blastId}
                  sx={{
                    mb: 2,
                    p: 1.5,
                    border: "1px solid rgba(255,255,255,0.15)",
                    borderRadius: 1.5,
                    backgroundColor: "rgba(255,255,255,0.05)",
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 600,
                      mb: 1,
                      wordBreak: "break-all",
                    }}
                  >
                    {blast.triggeredBy}
                  </Typography>

                  <Typography
                    variant="caption"
                    display="block"
                    sx={{ color: "rgba(255,255,255,0.7)" }}
                  >
                    <b>Started:</b> {blast.created}
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mt: 1.5,
                    }}
                  >
                    <Box>
                      <Typography
                        variant="caption"
                        sx={{ color: "rgba(255,255,255,0.7)" }}
                      >
                        <b>Emails</b>
                      </Typography>

                      <Typography variant="body2">
                        {blast.emailsCount.toLocaleString()}
                      </Typography>
                    </Box>

                    <Box sx={{ textAlign: "right" }}>
                      <Typography
                        variant="caption"
                        sx={{ color: "rgba(255,255,255,0.7)" }}
                      >
                        <b>Estimated Time</b>
                      </Typography>

                      <Typography variant="body2">
                        {blast.estimatedTime}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              ))
            )}
          </Box>
        }
      >

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            cursor: "pointer",
            fontSize: "15px"
          }}
        >
          <span>
            <CircleIcon
              color="success"
              sx={{ fontSize: 10 }}
            />
            <b> Blasts Running:</b> {blastsRunning}/{maxConcurrent}
          </span>

          <span>
            <CircleIcon
              color="primary"
              sx={{ fontSize: 10 }}
            />
            <b> Total Emails:</b> {emailsQueued.toLocaleString()}
          </span>

          <span>
            <CircleIcon
              color="secondary"
              sx={{ fontSize: 10 }}
            />
            <b> ETA:</b> {estimatedTime}
          </span>
        </Box>

      </Tooltip>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 0.5
        }}
      >
        <Typography
          variant="caption"
          sx={{ color: "rgba(255,255,255,.8)" }}
        >
          <i><b> Last Updated:</b> {statusLastUpdated}</i>
        </Typography>

        <Tooltip title="Refresh">
          <RefreshIcon
            onClick={handleEmailBlastStatusRefresh}
            sx={{
              cursor: "pointer",
              fontSize: 20
            }}
          />
        </Tooltip>
      </Box>

    </Box>
  );
};

const Navbar = ({ onTemplateClick }) => {
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [anchorElTemplates, setAnchorElTemplates] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = React.useState(false);
  const [selectedTemplateId, setSelectedTemplateId] = React.useState(null);

  const handleOpenDeleteModal = (templateId) => {
    setSelectedTemplateId(templateId);
    setIsDeleteModalOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setSelectedTemplateId(null);
    setIsDeleteModalOpen(false);
  };

  const handleTemplateDelete = (templateId) => {
    dispatch(deleteTemplateNameAsync(templateId));
    setAnchorElTemplates(null);
  };



  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchEmailBlastStatusAsync());
  }, [dispatch]);

  const role = useSelector(selectAdminClaim);
  const accessToken = Cookies.get('accessToken');
  const userEmail = jwt_decode(accessToken);

  useEffect(() => {
    dispatch(getEmailTemplateNamesAsync())
  }, [dispatch])

  const emailTemplateNames = useSelector(selectEmailTemplateNames)

  //handling user menu
  const handleOpenUserMenu = (event) => setAnchorElUser(event.currentTarget);
  const handleCloseUserMenu = () => setAnchorElUser(null);

  //handling email templates
  const handleTemplateMenuOpen = (event) => {
    dispatch(getEmailTemplateNamesAsync())
    setAnchorElTemplates(event.currentTarget);
  }
  const handleTemplateMenuClose = () => setAnchorElTemplates(null);

  const handleTemplateClick = (templateId) => {
    dispatch(updateTemplateAttachmentSelectOneS())
    dispatch(setTemplateId(templateId));
    dispatch(loadTemplateDataAsync(templateId))
    dispatch(incrementTemplateClick());
    //  onTemplateClick(templateId);
    setAnchorElTemplates(null);
  };

  // const handleTemplateDelete = (templateId) => {
  //   console.log(`Deleted Template: ${templateId}`);
  //   dispatch(deleteTemplateNameAsync(templateId))
  //   setAnchorElTemplates(null);
  // };

  const handleRefreshClick = () => {
    navigate('/user');
    dispatch(updateEmailBody())
    dispatch(updateTemplateAttachment())
    dispatch(updateTemplateAttachmentSelectOneS())

  }

  return (
    <>
      <AppBar position="fixed" sx={{ backgroundColor: '#1A4266' }} id="navbar">
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <img
              src={avatar}
              style={{ height: '40px', width: '40px', marginRight: '2%' }}
              alt="Logo"
            />
            <Typography
              variant="h6"
              noWrap
              component="a"
              sx={{
                mr: 2,
                display: { xs: 'none', md: 'flex' },
                fontFamily: 'monospace',
                fontWeight: 700,
                color: 'inherit',
                textDecoration: 'none',
              }}
            >
              Email Blaster
            </Typography>

            <Box sx={{ flexGrow: 1 }} />

            <EmailBlastStatusComponent />

            <Tooltip title="Email Templates">
              <Button
                sx={{
                  color: 'white',
                  textTransform: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  // marginRight: "-10px",

                }}
                endIcon={
                  Boolean(anchorElTemplates) ? (
                    <KeyboardArrowUpIcon />
                  ) : (
                    <KeyboardArrowDownIcon />
                  )
                }
                onClick={handleTemplateMenuOpen}
              >
                {/* Email Templates */}
                <EmailIcon sx={{ fontSize: 25, marginRight: '-6px' }} />
              </Button>
            </Tooltip>

            <Menu
              anchorEl={anchorElTemplates}
              open={Boolean(anchorElTemplates)}
              onClose={handleTemplateMenuClose}
              // sx={{ mt: '5px' }}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              {emailTemplateNames?.data?.fields && emailTemplateNames.data.fields.length > 0 ? (
                emailTemplateNames.data.fields.map(({ templateId, templateName }) => (
                  <MenuItem
                    key={templateId}
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      padding: '8px 16px',
                    }}
                  >
                    <ListItemText
                      onClick={() => handleTemplateClick(templateId)}
                      sx={{
                        fontSize: '14px',
                        cursor: 'pointer',
                        marginRight: '10px',
                      }}
                    >
                      {templateName}
                    </ListItemText>
                    <ListItemIcon
                      sx={{
                        minWidth: 'auto',
                        color: 'red',
                        cursor: 'pointer',
                        alignSelf: 'center',
                      }}
                      onClick={() => handleOpenDeleteModal(templateId)}
                    >
                      <DeleteIcon />
                    </ListItemIcon>
                  </MenuItem>
                ))
              ) : (
                <MenuItem
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '8px 16px',
                  }}
                >
                  <ListItemText
                    sx={{
                      fontSize: '10px',
                      color: 'gray',
                    }}
                  >
                    NA
                  </ListItemText>
                </MenuItem>
              )}

            </Menu>


            {/* Home Button */}
            {role === 0 && (
              <Tooltip title="Go To Excel Upload">
                <IconButton
                  color="inherit"
                  onClick={handleRefreshClick}
                  style={{ marginRight: '10px' }}
                >
                  <HomeOutlinedIcon />
                </IconButton>
              </Tooltip>
            )}

            {/* Dropdown for Email Templates */}

            {/* User Settings */}
            <Box sx={{ flexGrow: 0 }}>
              <Tooltip title="Open Settings">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar alt="User Avatar" src="/static/images/avatar/2.jpg" />
                </IconButton>
              </Tooltip>
              <AnimatedSettingsMenu
                anchorElUser={anchorElUser}
                onClose={handleCloseUserMenu}
                userEmail={userEmail}
                settings={settings}
              />
            </Box>
          </Toolbar>
        </Container>
      </AppBar>

      <Dialog
        open={isDeleteModalOpen}
        onClose={handleCloseDeleteModal}
        aria-labelledby="delete-confirmation-title"
        aria-describedby="delete-confirmation-description"
      >
        <DialogTitle id="delete-confirmation-title">
          Are you sure you want to delete this template?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-confirmation-description">
            This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteModal} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              handleTemplateDelete(selectedTemplateId);
              handleCloseDeleteModal();
            }}
            color="error"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Outlet />
    </>
  );
};


export default Navbar;
